<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <sidebar-item :routes='menuRoutes'></sidebar-item>
    </nav>
  </div>
</template>
<script>
import SidebarItem from './SidebarItem';
import { mapGetters } from 'vuex';
export default {
  name: 'sidebar',
  components: { SidebarItem },
  computed: {
    ...mapGetters(['addRouters']),
    menuRoutes() {
      if (!this.addRouters || !this.addRouters[0]) return [];
      // addRouters[0] 是 /main，取其 children 中有子菜单的顶级路由
      const children = this.addRouters[0].children || [];
      return children.filter(r => r.children && r.children.length > 0);
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
